'use client';

import dynamic from 'next/dynamic';
import type { BundleBuilderClientProps } from './bundle-builder-content';

// Keep the builder server-rendered while excluding its interactive catalog
// from routes whose CMS blocks do not use it.
const BundleBuilderContent = dynamic(() =>
	import('./bundle-builder-content').then((module) => module.BundleBuilderContent),
);

export function BundleBuilderClient(props: BundleBuilderClientProps) {
	return <BundleBuilderContent {...props} />;
}
